module.exports = __webpack_public_path__ + "static/Realty-bb9617d81738483a5fcfb0358c8800b3.mp4";